import { Numeric } from '../../types/general';

export function numericToCssUnit(value: Numeric): string {
  return typeof value === 'string' ? value : `${value}px`;
}
